// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1_n7r","cls2":"PaperNewsStory-cls2_LDi PaperNewsStory-cls1_n7r","variant-dense":"PaperNewsStory-variant-dense_sXA"};